import { Heading, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { General } from "./components/General";
import { ScopeThree } from "./components/ScopeThree";
import { Fragment, useState } from "react";
import * as React from "react";
import { ConsumptionBasedScopeOne } from "./components/ConsumptionBasedScopeOne";
import { ConsumptionBasedScopeTwo } from "./components/ConsumptionBasedScopeTwo";
import { t } from "i18next";

function ConsumptionBasedRevenue({ data, submitAndReturnToList, setSubmitAndReturnToList, handleNavigationToList, isPreview }) {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Fragment>
      <Tabs variant="unstyled" index={tabIndex} onChange={setTabIndex}>
        <TabList
          borderBottom="1px solid"
          borderColor="gray.200"
          sx={{
            "& > button": {
              mb: "-1px",
              py: 3,
              px: 4,
              fontSize: "15px",
              fontWeight: "600",
              color: "gray.400",
              borderBottom: "2px solid transparent",
              _selected: {
                color: "gray.800",
                borderBottom: "2px solid limegreen",
              },
            },
          }}
        >
          <Tab isDisabled={isPreview ? false : tabIndex !== 0}>{t("supplierQuestionnaire.revenueTabs.general")}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 1}>{`${t("supplierQuestionnaire.revenueTabs.scope")} 1`}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 2}>{`${t("supplierQuestionnaire.revenueTabs.scope")} 2`}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 3}>{`${t("supplierQuestionnaire.revenueTabs.scope")} 3`}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>
              {t("supplierQuestionnaire.general.title")}
            </Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">
              {t("supplierQuestionnaire.general.subtitle")}
            </Text>
            <General
              isTabActive={tabIndex === 0}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>
              {t("organizationQuestionnaire.scope1.info.title")}
            </Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">
              {t("organizationQuestionnaire.scope1.info.subtitle")}
            </Text>
            <ConsumptionBasedScopeOne
              isTabActive={tabIndex === 1}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>
              {t("organizationQuestionnaire.scope2.info.title")}
            </Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">
              {t("organizationQuestionnaire.scope2.info.subtitle")}
            </Text>
            <ConsumptionBasedScopeTwo
              isTabActive={tabIndex === 2}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>
              {t("supplierQuestionnaire.scopeThree.title")}
            </Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">
              {t("supplierQuestionnaire.scopeThree.subtitle")}
            </Text>
            <ScopeThree
              isTabActive={tabIndex === 3}
              id={data.id}
              categories={data.revenue?.categories ?? {}}
              consumptionBasedData={data.revenue?.consumptionBased ?? {}}
              questionnaireType={data.questionnaireType}
              isReviewModalUsed={false}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Fragment>
  );
}

export default ConsumptionBasedRevenue;